import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import { VenueSelectorPage } from "./pages/VenueSelectorPage.tsx";
import { FilmListingsPage } from "./pages/FilmListingsPage.tsx";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AboutPage } from "./pages/AboutPage.tsx";
import { RootLayout } from "./RootLayout.tsx";
import { cityLandingPageInfo } from "./data/fixedCityLocations.ts";
import { GenericLandingPage } from "./pages/GenericLandingPage.tsx";
import { CityLandingPage } from "./pages/CityLandingPage.tsx";
import { AllCinemasPage } from "./pages/AllCinemasPage.tsx";
import { IndividualCinemaPage } from "./pages/IndividualCinemaPage.tsx";
import { PopularFilmsOverviewPage } from "./pages/PopularFilmsOverviewPage.tsx";
import { IndividualPopularFilmPage } from "./pages/IndividualPopularFilmPage.tsx";
import { NotFoundPage } from "./pages/NotFoundPage.tsx";
import { TodayCityLandingPage } from "./pages/CityLandingPageForDay.tsx";
import { CitiesOverviewPage } from "./pages/CitiesOverviewPage.tsx";

const RedirectWhatsOnWithQueryString = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  if (params.has("venues")) {
    const venues = params.get("venues");
    if (typeof venues === "string") {
      params.delete("venues");
      params.append("cinemas", venues);
    }
  }

  const newUrl = `/films-showing?${params.toString()}`;

  return <Navigate to={newUrl} replace />;
};

const cityLandingPages: any = [];
const cityLandingPagesToday: any = [];
const cityLandingPagesTomorrow: any = [];

cityLandingPageInfo.forEach((info) => {
  cityLandingPages.push({
    path: `${info.slug}`,
    element: (
      <CityLandingPage
        locationText={info.locationName}
        slug={info.slug}
        availableVenuesText={info.cityAvailableVenuesText}
        latitude={info.cityLatitude}
        longitude={info.cityLongitude}
        nearby_venues={info.nearby_venues}
      />
    ),
  });
  cityLandingPagesToday.push({
    path: `${info.slug}/today`,
    element: (
      <TodayCityLandingPage
        locationText={info.locationName}
        citySlug={info.slug}
        availableVenuesText={info.cityAvailableVenuesText}
        latitude={info.cityLatitude}
        longitude={info.cityLongitude}
        nearby_venues={info.nearby_venues}
        dateLabels={["TODAY"]}
        dayText="Today"
        dateSlug="today"
      />
    ),
  });
  cityLandingPagesTomorrow.push({
    path: `${info.slug}/tomorrow`,
    element: (
      <TodayCityLandingPage
        locationText={info.locationName}
        citySlug={info.slug}
        availableVenuesText={info.cityAvailableVenuesText}
        latitude={info.cityLatitude}
        longitude={info.cityLongitude}
        nearby_venues={info.nearby_venues}
        dateLabels={["TOMORROW"]}
        dayText="Tomorrow"
        dateSlug="tomorrow"
      />
    ),
  });
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <GenericLandingPage /> },
      { path: "cinema-select", element: <VenueSelectorPage /> },
      { path: "whats-on", element: <RedirectWhatsOnWithQueryString /> },
      { path: "films-showing", element: <FilmListingsPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "cinemas", element: <AllCinemasPage /> },
      { path: "cinemas/:venueSlug", element: <IndividualCinemaPage /> },
      { path: "popular-films", element: <PopularFilmsOverviewPage /> },
      { path: "popular-cities", element: <CitiesOverviewPage /> },
      {
        path: "popular-films/:citySlug/:filmSlug",
        element: <IndividualPopularFilmPage />,
      },
      ...cityLandingPages,
      ...cityLandingPagesToday,
      ...cityLandingPagesTomorrow,
    ],
  },
]);

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export const App = () => {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div id="app=page">
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
};
